module.exports = __webpack_public_path__ + "img/rsz_1banner2.3199a8cf.jpg";